var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          {
            staticClass:
              "card-header d-flex justify-content-between align-items-center"
          },
          [
            _c("h4", { staticClass: "card-title mb-0" }, [
              _vm._v("Mis Entidades Asociadas")
            ]),
            _c(
              "div",
              { staticClass: "d-flex gap-2 align-items-center" },
              [
                _vm.totalCount > 0
                  ? _c("span", { staticClass: "text-muted small" }, [
                      _vm._v(
                        " Mostrando " +
                          _vm._s(_vm.entities.length) +
                          " de " +
                          _vm._s(_vm.totalCount) +
                          " entidades "
                      )
                    ])
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.loading
                    },
                    on: { click: _vm.refreshList }
                  },
                  [
                    !_vm.loading
                      ? _c("feather-icon", {
                          staticClass: "mr-1",
                          attrs: { icon: "RefreshCwIcon" }
                        })
                      : _c("span", {
                          staticClass: "spinner-border spinner-border-sm mr-1",
                          attrs: { role: "status" }
                        }),
                    _vm._v(" Actualizar ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            !_vm.loading && _vm.entities.length === 0
              ? _c(
                  "div",
                  { staticClass: "text-center py-5" },
                  [
                    _c("feather-icon", {
                      staticClass: "text-muted mb-3",
                      attrs: { icon: "BuildingIcon", size: "64" }
                    }),
                    _c("h5", { staticClass: "text-muted" }, [
                      _vm._v("No hay entidades asociadas")
                    ]),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        "No se encontraron entidades asociadas a tu usuario."
                      )
                    ])
                  ],
                  1
                )
              : _c("b-table", {
                  attrs: {
                    items: _vm.entities,
                    fields: _vm.fields,
                    busy: _vm.loading,
                    "empty-text": _vm.loading
                      ? "Cargando entidades..."
                      : "No hay entidades disponibles",
                    responsive: "sm",
                    striped: "",
                    hover: "",
                    "show-empty": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "cell(organismo)",
                      fn: function(row) {
                        return [
                          row.item.organismo
                            ? _c("div", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(row.item.organismo.organismoNombre)
                                  )
                                ]),
                                _c("br"),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "ID: " +
                                      _vm._s(row.item.organismo.organismoId)
                                  )
                                ])
                              ])
                            : _c("span", { staticClass: "text-muted" }, [
                                _vm._v("—")
                              ])
                        ]
                      }
                    },
                    {
                      key: "cell(entidad_padre)",
                      fn: function(row) {
                        return [
                          row.item.entidadPadreId && row.item.entidadPadreId > 0
                            ? _c("span", [
                                _vm._v(
                                  " ID: " +
                                    _vm._s(row.item.entidadPadreId) +
                                    " "
                                )
                              ])
                            : _c("span", { staticClass: "text-muted" }, [
                                _vm._v("—")
                              ])
                        ]
                      }
                    },
                    {
                      key: "cell(actions)",
                      fn: function(row) {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex gap-1" },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "outline-primary",
                                    title: "Ver detalles"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.viewEntityDetails(row.item)
                                    }
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "EyeIcon", size: "16" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
            _vm.totalPages > 1
              ? _c("b-pagination", {
                  staticClass: "mt-3",
                  attrs: {
                    "total-rows": _vm.totalCount,
                    "per-page": _vm.perPage,
                    "aria-controls": false,
                    align: "center",
                    size: "sm"
                  },
                  on: { input: _vm.onPageChange },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.selectedEntity
              ? "Entidad: " + _vm.selectedEntity.entidadNombre
              : "Detalles de Entidad",
            size: "lg",
            centered: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    { attrs: { variant: "secondary" }, on: { click: cancel } },
                    [_vm._v("Cerrar")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showDetailModal,
            callback: function($$v) {
              _vm.showDetailModal = $$v
            },
            expression: "showDetailModal"
          }
        },
        [
          _vm.selectedEntity
            ? _c("div", [
                _c("dl", { staticClass: "row mb-0" }, [
                  _c("dt", { staticClass: "col-sm-3" }, [_vm._v("ID Entidad")]),
                  _c("dd", { staticClass: "col-sm-9" }, [
                    _vm._v(_vm._s(_vm.selectedEntity.entidadId))
                  ]),
                  _c("dt", { staticClass: "col-sm-3" }, [_vm._v("Nombre")]),
                  _c("dd", { staticClass: "col-sm-9" }, [
                    _vm._v(_vm._s(_vm.selectedEntity.entidadNombre))
                  ]),
                  _c("dt", { staticClass: "col-sm-3" }, [
                    _vm._v("ID Entidad Padre")
                  ]),
                  _c("dd", { staticClass: "col-sm-9" }, [
                    _vm.selectedEntity.entidadPadreId &&
                    _vm.selectedEntity.entidadPadreId > 0
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEntity.entidadPadreId) +
                              " "
                          )
                        ])
                      : _c("span", { staticClass: "text-muted" }, [_vm._v("—")])
                  ]),
                  _c("dt", { staticClass: "col-sm-3" }, [_vm._v("Organismo")]),
                  _c("dd", { staticClass: "col-sm-9" }, [
                    _vm.selectedEntity.organismo
                      ? _c("div", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedEntity.organismo.organismoNombre
                              )
                            )
                          ]),
                          _c("br"),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              " ID Organismo: " +
                                _vm._s(
                                  _vm.selectedEntity.organismo.organismoId
                                ) +
                                " "
                            )
                          ])
                        ])
                      : _c("span", { staticClass: "text-muted" }, [_vm._v("—")])
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }